import bugsnag from "@bugsnag/js";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { ReactComponent as ArrowRightIcon } from "@Icons/16x16/arrow-right.svg";
import { Tile } from "@Types/pagify";
import { getLink } from "@Utils/pagify";
import "./style.scss";

export const HomeCategoriesItemMobile: FunctionComponent<{ tile: Tile }> = ({ tile }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const tileTitle = tile.textBlock1 && tile.textBlock1[0].text;
  const tileImage = tile.images.length > 0 && tile.images[0].desktop;
  const tileLink = getLink(tile.navigationLink, localeSlug);

  if (!tileImage) {
    bugsnag.notify(new Error(`image for tile ${tile.slug} not found in HomeCategoriesItemMobile`));
  }

  return (
    <a className="HomeCategoriesItemMobile" href={tileLink}>
      <h3 className="HomeCategoriesItemMobile-title">{tileTitle}</h3>
      <div className="HomeCategoriesItemMobile-right">
        {!!tileImage && (
          <div className="HomeCategoriesItemMobile-image-wrapper">
            <img
              alt={`${tileTitle ? tileTitle : ""} Cheerz`}
              className="HomeCategoriesItemMobile-image"
              src={tileImage["1x"]}
              srcSet={`${tileImage["1x"]} 1x, ${tileImage["2x"]} 2x`}
            />
          </div>
        )}
        <ButtonSmily icon={<ArrowRightIcon />} iconPosition="alone" size="s" type="secondary" />
      </div>
    </a>
  );
};
